import { type ScanContext } from '../types/scanContext.type';
import { type RawScanEvent, type ScanEvent } from '../types/scanEvent.type';
import { normalizeBarcodeValue } from './normalization.util';

export const createScanEvent = (
  rawScanEvent: RawScanEvent,
  scanContext: ScanContext,
): ScanEvent => ({
  ...rawScanEvent,
  barcode_value: normalizeBarcodeValue(rawScanEvent.barcode_value),
  scan_context: scanContext,
});
